if (!customElements.get('before-after-card')) {
  class BeforeAfterCard extends HTMLElement {
    constructor() {
      super();
      this.media = this.querySelector('.before-after-card__media');
      this.afterImage = this.querySelector('.before-after-card__image--after');
      this.slider = this.querySelector('.before-after-card__slider');

      if (!this.media || !this.afterImage || !this.slider) return;

      this.isDragging = false;
      this.currentPosition = 50;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      this.slider.addEventListener('pointerdown', this.onPointerDown);
      this.slider.addEventListener('keydown', this.onKeyDown);

      this.updatePosition(this.currentPosition);
      this.classList.add('is-loaded');
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      event.preventDefault();

      this.isDragging = true;
      this.slider.setPointerCapture(event.pointerId);
      this.slider.addEventListener('pointermove', this.onPointerMove);
      this.slider.addEventListener('pointerup', this.onPointerUp);
      this.slider.addEventListener('pointercancel', this.onPointerUp);

      const rect = this.media.getBoundingClientRect();
      const percent = ((event.clientX - rect.left) / rect.width) * 100;
      this.updatePosition(Math.max(0, Math.min(100, percent)));
    }

    onPointerMove(event) {
      if (this.isDragging === false) return;
      const rect = this.media.getBoundingClientRect();
      const percent = ((event.clientX - rect.left) / rect.width) * 100;
      this.updatePosition(Math.max(0, Math.min(100, percent)));
    }

    onPointerUp(event) {
      this.isDragging = false;
      if (this.slider.hasPointerCapture(event.pointerId)) {
        this.slider.releasePointerCapture(event.pointerId);
      }
      this.slider.removeEventListener('pointermove', this.onPointerMove);
      this.slider.removeEventListener('pointerup', this.onPointerUp);
      this.slider.removeEventListener('pointercancel', this.onPointerUp);
    }

    onKeyDown(event) {
      const step = event.shiftKey ? 10 : 2;

      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowDown':
          event.preventDefault();
          this.updatePosition(Math.max(0, this.currentPosition - step));
          break;
        case 'ArrowRight':
        case 'ArrowUp':
          event.preventDefault();
          this.updatePosition(Math.min(100, this.currentPosition + step));
          break;
        case 'Home':
          event.preventDefault();
          this.updatePosition(0);
          break;
        case 'End':
          event.preventDefault();
          this.updatePosition(100);
          break;
        default:
          break;
      }
    }

    updatePosition(percent) {
      this.currentPosition = percent;
      this.slider.style.left = `${percent}%`;
      this.afterImage.style.clipPath = `inset(0 0 0 ${percent}%)`;
      this.slider.setAttribute('aria-valuenow', Math.round(percent));
    }
  }

  customElements.define('before-after-card', BeforeAfterCard);
}
